import en from './en.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';
import Chinese from './locales/zh.js';
import Japanese from './locales/jp.js';
import Chinese_Tw from './locales/zh-tw.js';
export default {
  en: en,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
  'zh-cn': Chinese,
  'ja-jp': Japanese,
  'zh-tw': Chinese_Tw
};